import React from "react";
import "../styles/ServiceIntroSection.css";
import icon from "../images/icon.png";
import linectImage from "../images/Linect.png";
import question from "../images/question.png";
import logo from "../images/logo.png";
import point1Image from "../images/point1.png";
import point2Image from "../images/point2.png";
import point3Image from "../images/point3.png";

function ServiceIntroSection() {
  return (
    <section id="service-intro">
      <div className="service-intro">
        <div className="service-intro-content">
          <h2 className="service-title">
            <img src={icon} alt="Linect Icon" className="service-icon" />
            とは？
          </h2>
          <p className="service-description1">
            Linectは、LINE公式アカウントの全体設計・作成・開発・運用をサポートするサービスです。
          </p>
          <p className="service-description2">
            Linectを活用することで、顧客とのつながりを強化します。<br></br>
            公式LINEを通じて、お客様がもっと便利で身近に感じる体験を提供し、売上と信頼を同時にアップしましょう。
          </p>
        </div>
        <div className="service-image">
          <img src={linectImage} alt="Linect" className="linect-image" />
        </div>
      </div>

      <div className="points-wrapper">
        <h3 className="points-title">
          公式LINEの運用について、<br></br>こんなお悩みありませんか？
        </h3>
        <div className="points-question">
          <div className="points-section">
            <p className="point-title">・使い方がよく分からない</p>
            <p className="point-title">・リピーターに繋がらない</p>
            <p className="point-title">・友だちの数が増えない</p>
            <p className="point-title">・効果が実感できない</p>
          </div>
          <div className="service-image2">
            <img src={question} alt="question" className="question-image" />
          </div>
        </div>
      </div>

      <div className="solution-message">
        <p className="arrow-icon">▼</p>
        <p className="solution-text">
          そのお悩み、
          <img src={logo} alt="linect" className="linect-icon" />
          で解決できます！！
        </p>
      </div>

      <div className="additional-points-section">
        <div className="additional-point">
          <div className="additional-point-number" data-number="1"></div>
          <p className="additional-point-title">集客方法の提案</p>
          <span className="additional-point-sab">
            新規顧客の獲得や既存顧客の強化のための効果的なアプローチ方法をご提案します。お客様のビジネスに合わせた、集客・リピート率向上のためのオリジナルプランをご提供いたします。
          </span>
          <img
            src={point1Image}
            alt="Point 1"
            className="additional-point-image"
          />
        </div>
        <div className="additional-point">
          <div className="additional-point-number" data-number="2"></div>
          <p className="additional-point-title">機能の開発</p>
          <span className="additional-point-sab">
            必要な機能をお客様のニーズに合わせて開発し、提供いたします。複数のツールを統合しながら、LINEでの顧客対応やマーケティングを効果的にサポートし、信頼と売上の向上に繋げます。
          </span>
          <img
            src={point2Image}
            alt="Point 2"
            className="additional-point-image"
          />
        </div>
        <div className="additional-point">
          <div className="additional-point-number" data-number="3"></div>
          <p className="additional-point-title">低価格+安心のサポート</p>
          <span className="additional-point-sab">
            継続的な運用を支えるため、手頃な価格で安心してご利用いただけるサポート体制をご提供します。ご希望や課題に迅速に対応し、安定した運用ができるよう全力でサポートいたします。
          </span>
          <img
            src={point3Image}
            alt="Point 3"
            className="additional-point-image"
          />
        </div>
      </div>
    </section>
  );
}

export default ServiceIntroSection;
